import React from 'react'

import AnexoBContent from './sections/AnexoBContent'
import AnexoCContent from './sections/AnexoCContent'
import Separator from '../../../../components/pdf/Separator'

const CiiPageContent = () => {
  return (
    <>
      <AnexoBContent />
      <Separator weight={10} />
      <AnexoCContent />
    </>
  )
}

export default CiiPageContent
